const state = {
  panelState: 1,
  userState: false,
};

export default state;
